import React from "react";
import { ExternalLink } from "lucide-react";
import { Badge } from "./TeacherMocksShared";
import {
  difficultyBadgeVariant,
  cognitiveBadgeVariant,
  getFirstStem,
  getQuestionCourseNames,
  stripHtml,
  difficultyLabels,
  cognitiveLabels,
  formatLabels,
} from "./teacherMocksHelpers";

export default function QuestionPreview({ question, action, disabled, prefix, selected, onToggle }) {
  const firstStemContent = getFirstStem(question);
  const emptyValue = "<p style=\"text-align: left;\"></p>";
  const displayContent = firstStemContent && firstStemContent !== emptyValue
    ? `${question.context || ""}<br/><br/>${firstStemContent}`
    : question.context || "";
  const courseNames = getQuestionCourseNames(question);

  const isSelectable = !!onToggle && !disabled;

  const handleRowClick = (event) => {
    if (!isSelectable) return;
    if (event.target.closest("button, a, input")) return;
    onToggle();
  };

  const classNames = [
    "teacher-mocks-question-preview",
    disabled ? "disabled" : "",
    selected ? "selected" : "",
    isSelectable ? "selectable" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className={classNames} onClick={handleRowClick}>
      <div className="teacher-mocks-question-preview-top">
        <div className="teacher-mocks-question-main">
          {onToggle && (
            <input
              type="checkbox"
              className="teacher-mocks-question-checkbox"
              checked={!!selected}
              disabled={disabled}
              onChange={() => { if (!disabled) onToggle(); }}
              onClick={(e) => e.stopPropagation()}
              aria-label={`Selecionar questão #${question.id}`}
            />
          )}
          <div className="teacher-mocks-question-tags">
            <span className="teacher-mocks-question-id">#{String(question.id)}</span>
            {prefix && <span className="teacher-mocks-question-position">{prefix}</span>}
            {question.difficultyLevel && (
              <Badge variant={difficultyBadgeVariant(question.difficultyLevel)}>
                {difficultyLabels[question.difficultyLevel] || question.difficultyLevel}
              </Badge>
            )}
            {question.cognitiveLevel && (
              <Badge variant={cognitiveBadgeVariant(question.cognitiveLevel)}>
                {cognitiveLabels[question.cognitiveLevel] || question.cognitiveLevel}
              </Badge>
            )}
            {question.format && (
              <Badge variant={question.format === "case" ? "pink" : "secondary"}>
                {formatLabels[question.format] || question.format}
              </Badge>
            )}
            {question.highlighted && <Badge variant="yellow">Recorrente</Badge>}
            {question.calcRequired && <Badge variant="orange">Requer Calculo</Badge>}
            {courseNames.map((name) => <Badge key={name} variant="outline">{name}</Badge>)}
          </div>
        </div>
        <div className="teacher-mocks-question-actions">
          <button type="button" onClick={() => window.open(`/manager/v2/questions/${question.id}/edit`, "_blank")}>
            <ExternalLink size={12} aria-hidden="true" />
            Abrir
          </button>
          {action}
        </div>
      </div>
      <div className="teacher-mocks-question-content">
        {stripHtml(displayContent)}
      </div>
    </div>
  );
}
